export default  {
    bindings: {
        property: '<',
        formTab: '=',
        type: '@'
    },
    controller: 'propertyIntegrationFormController',
    template: require('../views/property.integration.form.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/components/property.integration.form.component.js